$(document).ready(function () {
  $(document).on('click', '.mobile-header-mega-menu-list', function() {
    if ($('.accordion-content').is(':visible')) {
       $('.accordion-content').slideUp(300);
       $('.icon.icon-down').removeClass('updown-accordion-icon-show');
    }
    if ($(this).next('.accordion-content').is(':visible')) 
    {
      $(this).next('.accordion-content').slideUp(300);
      $(this).find('.icon.icon-down').removeClass('updown-accordion-icon-show');
    } 
    else
    {
      $(this).next('.accordion-content').slideDown(300);
      $(this).find('.icon.icon-down').addClass('updown-accordion-icon-show');
    }
  });

  // $('.megamenu-item-carousel').flickity({
  //     cellAlign: 'left',
  //     contain: true,
  //     prevNextButtons: false,
  //     pageDots: false
  // });

});
